import React from 'react'
import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'
import globalConfig from '../../../../../components/Organisms/Form/config'

import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

import { ConfigCompanyDetails } from '../../CorporateAccount/CompanyDetails/types'
import Label from 'src/components/Atoms/Label/Label'

const LabelCurrentEmployerTime = (
  <Label
    key='labelInputFIlesSection'
    label={t('onboarding.forms.IndividualAccount.PersonalDetailsForm.visualOnly.employedTime')}
    gridArea='employedTime'
    required
    removeEllipsis
  />
)

const LabelPreviousEmployer = (
  <Label
    key='labelPreviousEmployerText'
    label={t('onboarding.forms.IndividualAccount.PersonalDetailsForm.visualOnly.previousEmployerText')}
    gridArea='previousEmployerText'
    required
    removeEllipsis
    bold
  />
)

const LabelPreviousAddress = (
  <Label
    key='labelPreviousAddressText'
    label={t('onboarding.forms.IndividualAccount.PersonalDetailsForm.visualOnly.previousAddressText')}
    gridArea='previousAddressText'
    required
    removeEllipsis
    bold
  />
)

const config = ({ countries, countryTelephoneCodes }: ConfigCompanyDetails) => utils.injectTranslation({
  id: 'PersonalDetailsForm',
  path: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
      },
      content: [
        {
          id: 'PersonalDetailsForm',
          path: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs',
          componentType: 'grid',
          content: [
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '1fr 1fr',
                gridTemplateAreas:
                ' \'title otherTitle\' \'firstName firstName\' \'surname surname\' \'previousNames previousNames\' \'dateOfBirth placeOfBirth\' \'nationality nationality\' \'dayTimeTelephoneCountryIndex dayTimeTelephone\' \'eveningTelephoneCountryIndex eveningTelephone\' \'faxNumberCountryIndex faxNumber\' \'mobileNumberCountryIndex mobileNumber\' \'permanentResdentialAddress permanentResdentialAddress\' \'permanentCity permanentPostCode\' \'permanentCountry .\' \'dailyTradingStatementEmailAddress dailyTradingStatementEmailAddress\' \'livingTime livingTime\' \'currentAddressLivingYears currentAddressLivingMonths\' \'previousAddressText previousAddressText\' \'previousStreet previousStreet\' \'previousTown previousPostcode\' \'previousCountry .\' ',
                marginBottom: 'auto',
              },
              content: [
                {
                  componentType: 'dropdown',
                  transformType: 'getValueFromIndex',
                  props: {
                    name: 'title',
                    gridArea: 'title',
                    required: true,
                    removeEllipsis: true,
                    width: '48%',
                    dontClearValue: true,
                    noReset: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'otherTitle',
                    gridArea: 'otherTitle',
                    required: true,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'firstName',
                    gridArea: 'firstName',
                    required: true,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'surname',
                    gridArea: 'surname',
                    required: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousNames',
                    gridArea: 'previousNames',
                  },
                },
                {
                  componentType: 'date',
                  transformType: 'date',
                  submitValidation: 'date',
                  props: {
                    name: 'dob',
                    gridArea: 'dateOfBirth',
                    tooltipLabel: t('onboarding.forms.IndividualAccount.PersonalDetailsForm.visualOnly.dob'),
                    noFuture: true,
                    required: true,
                    dontClearValue: true,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'placeOfBirth',
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countries,
                    name: 'placeOfBirth',
                    label: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.placeOfBirth.label',
                    placeholder: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.placeOfBirth.placeholder',
                    required: true,
                    filter: true,
                    gridArea: 'placeOfBirth',
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'nationality',
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countries,
                    name: 'nationality',
                    label: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.nationality.label',
                    placeholder: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.nationality.placeholder',
                    required: true,
                    filter: true,
                    gridArea: 'nationality',
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'dayTimeTelephoneCountryIndex',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countryTelephoneCodes,
                    name: 'dayTimeTelephoneCountryIndex',
                    label: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.dayTimeTelephoneCountryIndex.label',
                    placeholder: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.dayTimeTelephoneCountryIndex.placeholder',
                    wrapperMinHeight: '91px',
                    required: true,
                    filter: true,
                    gridArea: 'dayTimeTelephoneCountryIndex',
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  submitValidation: 'telephone',
                  props: {
                    name: 'dayTimeTelephone',
                    gridArea: 'dayTimeTelephone',
                    pattern: globalConfig?.regex?.telephone,
                    required: true
                  },
                },
                {
                  componentType: 'input',
                  transformType: 'transformValidationTelephoneCodePlusNumber',
                  props: {
                    name: 'validationDayTimeTelephoneCountryIndex',
                    show: false,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'eveningTelephoneCountryIndex',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countryTelephoneCodes,
                    name: 'eveningTelephoneCountryIndex',
                    label: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.eveningTelephoneCountryIndex.label',
                    placeholder: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.eveningTelephoneCountryIndex.placeholder',
                    wrapperMinHeight: '91px',
                    gridArea: 'eveningTelephoneCountryIndex',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  submitValidation: 'telephone',
                  props: {
                    name: 'eveningTelephone',
                    gridArea: 'eveningTelephone',
                    pattern: globalConfig?.regex?.telephone,
                    required: true
                  }
                },
                {
                  componentType: 'input',
                  transformType: 'transformValidationTelephoneCodePlusNumber',
                  props: {
                    name: 'validationEveningTelephoneCountryIndex',
                    show: false,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'faxNumberCountryIndex',
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countryTelephoneCodes,
                    name: 'faxNumberCountryIndex',
                    label: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.faxNumberCountryIndex.label',
                    placeholder: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.faxNumberCountryIndex.placeholder',
                    wrapperMinHeight: '91px',
                    filter: true,
                    gridArea: 'faxNumberCountryIndex',
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  submitValidation: 'telephone',
                  props: {
                    name: 'faxNumber',
                    gridArea: 'faxNumber',
                    pattern: globalConfig?.regex?.telephone,
                  },
                },
                {
                  componentType: 'input',
                  transformType: 'transformValidationTelephoneCodePlusNumber',
                  props: {
                    name: 'validationFaxNumberCountryIndex',
                    show: false,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'mobileNumberCountryIndex',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countryTelephoneCodes,
                    name: 'mobileNumberCountryIndex',
                    label: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.mobileNumberCountryIndex.label',
                    placeholder: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.mobileNumberCountryIndex.placeholder',
                    wrapperMinHeight: '91px',
                    gridArea: 'mobileNumberCountryIndex',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  submitValidation: 'telephone',
                  props: {
                    name: 'mobileNumber',
                    gridArea: 'mobileNumber',
                    pattern: globalConfig?.regex?.telephone,
                    required: true,
                  },
                },
                {
                  componentType: 'input',
                  transformType: 'transformValidationTelephoneCodePlusNumber',
                  props: {
                    name: 'validationMobileNumberCountryIndex',
                    show: false,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'permanentResdentialAddress',
                    gridArea: 'permanentResdentialAddress',
                    required: true,
                    isTextarea: true,
                    textAreaHeight: '32px',
                    textAreaPointerEvents: 'auto',
                    resize: 'none'
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'permanentCity',
                    gridArea: 'permanentCity',
                    required: true,
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'permanentPostCode',
                    gridArea: 'permanentPostCode',
                    required: true,
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'permanentCountry',
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countries,
                    name: 'permanentCountry',
                    label: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.permanentCountry.label',
                    placeholder: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.permanentCountry.placeholder',
                    required: true,
                    gridArea: 'permanentCountry',
                    filter: true,
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  submitValidation: 'email',
                  props: {
                    name: 'dailyTradingStatementEmailAddress',
                    gridArea: 'dailyTradingStatementEmailAddress',
                    required: true
                  }
                },
                {
                  componentType: 'label',
                  props: {
                    label: t('onboarding.forms.IndividualAccount.PersonalDetailsForm.visualOnly.livingTime'),
                    gridArea: 'livingTime',
                    required: true,
                  }
                },
                {
                  componentType: 'input',
                  transformType: 'stringToNumOrViceVersa',
                  props: {
                    name: 'currentAddressLivingYears',
                    gridArea: 'currentAddressLivingYears',
                    minHeight: '0',
                    removeLabelEllipsis: true,
                    required: true,
                    pattern: globalConfig?.regex?.number,
                    maxlength: '2',
                  }
                },
                {
                  componentType: 'input',
                  transformType: 'stringToNumOrViceVersa',
                  props: {
                    name: 'currentAddressLivingMonths',
                    gridArea: 'currentAddressLivingMonths',
                    minHeight: '0',
                    required: true,
                    pattern: globalConfig?.regex?.number,
                    maxlength: '2',
                  }
                },
                {
                  visualComponent: LabelPreviousAddress,
                  visualName: 'previousAddressText',
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousStreet',
                    gridArea: 'previousStreet',
                    required: true,
                    isTextarea: true,
                    textAreaHeight: '32px',
                    textAreaPointerEvents: 'auto',
                    resize: 'none'
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousTown',
                    gridArea: 'previousTown',
                    required: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousPostcode',
                    gridArea: 'previousPostcode',
                    required: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousCountry',
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countries,
                    name: 'previousCountry',
                    label: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.previousCountry.label',
                    placeholder: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.previousCountry.placeholder',
                    gridArea: 'previousCountry',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
              ],
            },
          ],
        },
        {
          id: 'PersonalDetailsForm',
          path: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs',
          componentType: 'grid',
          content: [
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '1fr 1fr',
                gridTemplateAreas:
                  '\'maritalStatus noOfDependants\' \'employmentStatus .\' \'occupationLabel occupationLabel\' \'occupation occupation\' \'companyName companyName\' \'typeOfBusiness typeOfBusiness\' \'companyAddress companyAddress\' \'companyCity companyPostCode\' \'companyCountry companyCountry\' \'employedTime employedTime\' \'currentEmploymentDurationYears currentEmploymentDurationMonths\' \'previousEmployerText previousEmployerText\' \'previousEmployerOccupation previousEmployerOccupation\' \'previousEmployerName previousEmployerName\' \'previousEmployerType previousEmployerType\' \'previousEmployerAddress previousEmployerAddress\' \'previousEmployerTown previousEmployerPostcode\' \'previousEmployerCountry .\'',
                marginBottom: 'auto',
              },
              content: [
                {
                  componentType: 'dropdown',
                  transformType: 'getValueFromIndex',
                  props: {
                    name: 'maritalStatus',
                    gridArea: 'maritalStatus',
                    removeEllipsis: true,
                    width: '48%',
                    required: true,
                    dontClearValue: true,
                    noReset: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'noOfDependants',
                    gridArea: 'noOfDependants',
                    required: true
                  },
                },
                {
                  componentType: 'dropdown',
                  transformType: 'getValueFromIndex',
                  props: {
                    name: 'employmentStatus',
                    gridArea: 'employmentStatus',
                    removeEllipsis: true,
                    required: true,
                    dontClearValue: true,
                    noReset: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'employerOccupation',
                    gridArea: 'occupation',
                    required: true,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'companyName',
                    gridArea: 'companyName',
                    required: true,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'typeOfBusiness',
                    gridArea: 'typeOfBusiness',
                    required: true,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'companyAddress',
                    gridArea: 'companyAddress',
                    required: true,
                    isTextarea: true,
                    textAreaHeight: '32px',
                    textAreaPointerEvents: 'auto',
                    resize: 'none'
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'companyCity',
                    gridArea: 'companyCity',
                    required: true,
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'companyPostCode',
                    gridArea: 'companyPostCode',
                    required: true,
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'companyCountry',
                    required: true
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countries,
                    name: 'companyCountry',
                    label: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.companyCountry.label',
                    placeholder: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.companyCountry.placeholder',
                    required: true,
                    filter: true,
                    gridArea: 'companyCountry',
                    ...props
                  })
                },
                {
                  visualComponent: LabelCurrentEmployerTime,
                  visualName: 'employedTimeLabel',
                },
                {
                  componentType: 'input',
                  transformType: 'stringToNumOrViceVersa',
                  props: {
                    name: 'currentEmploymentDurationYears',
                    gridArea: 'currentEmploymentDurationYears',
                    minHeight: '0',
                    removeLabelEllipsis: true,
                    required: true,
                    pattern: globalConfig?.regex?.number,
                    maxlength: '2',
                  }
                },
                {
                  componentType: 'input',
                  transformType: 'stringToNumOrViceVersa',
                  props: {
                    name: 'currentEmploymentDurationMonths',
                    gridArea: 'currentEmploymentDurationMonths',
                    minHeight: '0',
                    required: true,
                    pattern: globalConfig?.regex?.number,
                    maxlength: '2',
                  }
                },
                {
                  visualComponent: LabelPreviousEmployer,
                  visualName: 'previousEmployerText',
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousEmployerOccupation',
                    gridArea: 'previousEmployerOccupation',
                    required: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousEmployerName',
                    gridArea: 'previousEmployerName',
                    required: true,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousEmployerType',
                    gridArea: 'previousEmployerType',
                    required: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousEmployerAddress',
                    gridArea: 'previousEmployerAddress',
                    required: true,
                    isTextarea: true,
                    textAreaHeight: '32px',
                    textAreaPointerEvents: 'auto',
                    resize: 'none'
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousEmployerTown',
                    gridArea: 'previousEmployerTown',
                    required: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousEmployerPostcode',
                    gridArea: 'previousEmployerPostcode',
                    required: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'previousEmployerCountry',
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countries,
                    name: 'previousEmployerCountry',
                    label: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.previousEmployerCountry.label',
                    placeholder: 'onboarding.forms.IndividualAccount.PersonalDetailsForm.inputs.previousEmployerCountry.placeholder',
                    gridArea: 'previousEmployerCountry',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
              ],
            },
          ],
        },
      ],
    },
  ],
})

export default config
